import { createSelector } from '@ngrx/store';
import { getRouterState } from '../store/store.selectors';

export const getCurrentRoute = createSelector(
  getRouterState,
  (state: any) => state
);
